export default __webpack_public_path__ + "static/media/ic_canto_40.987fb388.svg";